import { Stack } from '@mui/material';

const NoResultsOverlay = () => (
  <Stack height="100%" alignItems="center" justifyContent="center">
    No data was retrieved.
  </Stack>
);

export default NoResultsOverlay;
